import type { SVGProps } from 'react';
const SvgNews = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 27 25"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF073B"
      fillRule="evenodd"
      d="M13.393 3.653a.694.694 0 0 0-1.102-.185L6.527 9.04l4.01 7.894 7.92-1.316a.694.694 0 0 0 .506-1zm-2.197 14.58 7.49-1.245A2.083 2.083 0 0 0 20.2 13.99l-5.57-10.966a2.083 2.083 0 0 0-3.305-.554L5.268 8.326 1.14 10.422a2.083 2.083 0 0 0-.914 2.801l3.248 6.395a2.083 2.083 0 0 0 2.801.914l.872-.443 1.83 3.602a2.083 2.083 0 0 0 2.8.914l.254-.129a2.083 2.083 0 0 0 .914-2.8zm-1.319.47-1.491.757 1.83 3.602a.694.694 0 0 0 .933.305l.253-.129a.694.694 0 0 0 .305-.933zm-.629-1.239L5.371 9.831l-3.602 1.83a.694.694 0 0 0-.304.933l3.248 6.395a.694.694 0 0 0 .933.305zM20.402.208a.694.694 0 0 1-.009.982l-3.019 2.964a.694.694 0 0 1-.973-.99L19.42.198a.694.694 0 0 1 .982.009M23.954 4.236a.694.694 0 0 1-.271.944l-4.556 2.523a.695.695 0 0 1-.673-1.215l4.556-2.523a.694.694 0 0 1 .944.27M26.008 9.323a.695.695 0 0 1-.523.831l-4.638 1.055a.694.694 0 1 1-.308-1.355L25.177 8.8a.694.694 0 0 1 .831.523"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNews;
